export const SITE_NAME = 'Cobalt';
export const SITE_URL = 'https://gocobalt.io';
export const SITE_DESCRIPTION = 'Cobalt is an embedded iPaaS for SaaS. Say &quot;yes&quot; to enterprise requests, ship 10x faster, build with native UI/UX and seamless API connectors. Say goodbye to infrastructure worries and maintenance hassles—enjoy a platform built for integration teams.';

export const META = {
  DEFAULT_TITLE: `${SITE_NAME} - Embedded integration Platform for SaaS | Embedded iPaaS`,
  DEFAULT_DESCRIPTION: SITE_DESCRIPTION,
  DEFAULT_KEYWORDS: ['Embedded Integration Platform', 'Embedded iPaaS', 'SaaS Integration', 'Enterprise Integration', 'API Connectors', 'Integration Platform', 'Integration as a Service', 'SaaS Integration Platform', 'SaaS Integration Platform', 'SaaS Integration Platform'],
  DEFAULT_OG_IMAGE: `${SITE_URL}/title-logo-black.png`,

  // Home Page
  HOME: {
    TITLE: 'Cobalt - Embedded Integration Platform for SaaS | Embedded iPaaS',
    DESCRIPTION: 'Streamline SaaS integrations with Cobalt\'s embedded iPaaS. White-labeled, scalable solutions for seamless connectivity.',
  },

  // Product Overview Page
  PRODUCT: {
    TITLE: 'Product Overview - White-labeled, Native App Integrations | Cobalt',
    DESCRIPTION: 'Explore Cobalt\'s white-labeled integrations. Connect apps natively with our embedded iPaaS platform.',
  },

  // Pricing Page
  PRICING: {
    TITLE: 'Pricing Plans for Flexible Embedded iPaaS Solutions | Cobalt',
    DESCRIPTION: 'Discover Cobalt\'s flexible pricing plans for embedded iPaaS. Scale integrations affordably for your SaaS.',
  },

  // About Us Page
  ABOUT: {
    TITLE: 'Our Story | About Cobalt',
    DESCRIPTION: 'Learn about Cobalt\'s mission to simplify SaaS integrations with an innovative embedded iPaaS solution.',
  },

  // Contact Us Page
  CONTACT: {
    TITLE: 'Contact Us - Reach Out for a Demo | Cobalt',
    DESCRIPTION: 'Get in touch with Cobalt for a demo of our embedded iPaaS platform and transform your SaaS integrations.',
  },

  // Sign Up Page
  SIGNUP: {
    TITLE: 'Sign Up for Cobalt | Simplify SaaS Integrations with Embedded iPaaS',
    DESCRIPTION: 'Sign up for Cobalt and simplify SaaS integrations with our scalable, white-labeled iPaaS platform.',
  },

  // Integrations Catalog Page
  INTEGRATIONS: {
    TITLE: 'Comprehensive Integrations Catalog of 1,000+ Connectors | Cobalt',
    DESCRIPTION: 'Access 1,000+ connectors in Cobalt\'s catalog for seamless, embedded SaaS integrations.',
  },

  // AI-Powered Integrations Page
  AI_INTEGRATIONS: {
    TITLE: 'Discover the Future of AI-Powered Integrations with Cobalt',
    DESCRIPTION: 'Unlock AI-powered integrations with Cobalt\'s embedded iPaaS for smarter SaaS connectivity.',
  },

  // Blog Page
  BLOG: {
    TITLE: 'Cobalt: The Blog for Embedded Integrations',
    DESCRIPTION: 'Read Cobalt\'s blog for insights on embedded integrations and iPaaS trends for SaaS.',
  },

  // Changelog Page
  CHANGELOG: {
    TITLE: 'Cobalt Changelog - Latest Updates and Features',
    DESCRIPTION: 'Stay updated with Cobalt\'s changelog: new features and improvements for our iPaaS platform.',
  },

  // Solutions for Product Teams Page
  PRODUCT_TEAMS: {
    TITLE: 'Unlock Embedded Integration Solutions for Product Teams | Cobalt',
    DESCRIPTION: 'Empower product teams with Cobalt\'s embedded iPaaS for seamless SaaS integrations.',
  },

  // Careers Page
  CAREERS: {
    TITLE: 'Join Our Team | Careers at Cobalt',
    DESCRIPTION: 'Explore career opportunities at Cobalt and join our mission to transform SaaS integrations with our innovative embedded iPaaS platform.',
  }
} as const;
